module.exports = __webpack_public_path__ + "img/c05_unitscout_Normal_ua.97b8e9c4.webp";